import { z } from 'zod';

export const deleteAccountPostRequestSchema = z.object({ password: z.string() });
